module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.0435e9b3.png";